exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-8f1ebbba]{padding-bottom:0}.xm-content[data-v-8f1ebbba]{position:relative;width:100%;padding:0;margin:0;border-radius:6px;background:#fff}.go-home[data-v-8f1ebbba]{position:fixed;right:0;bottom:80px;height:28px;padding:0 .6em 0 1em;line-height:28px;border-top-left-radius:14px;border-bottom-left-radius:14px;color:#fff;background:#0884f3}", ""]);

// exports
